// extracted by mini-css-extract-plugin
export var attribution = "_au-4";
export var authorName = "_au-5";
export var quote = "_au-3";
export var testimonial = "_au-2";
export var trustedBy = "_au-0";
export var trustedByLabel = "_au-1";